import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "editor", "select", "input", "form"]
  static values = {
    currentTopic: String
  }

  connect() {
    this.boundCloseOnOutsideClick = this.closeOnOutsideClick.bind(this)
    this.boundDialogClose = this.handleDialogClose.bind(this)

    if (this.hasEditorTarget && this.editorTarget.tagName === "DIALOG") {
      this.editorTarget.addEventListener("close", this.boundDialogClose)
    }
  }

  disconnect() {
    document.removeEventListener("click", this.boundCloseOnOutsideClick)
    if (this.hasEditorTarget && this.editorTarget.tagName === "DIALOG") {
      this.editorTarget.removeEventListener("close", this.boundDialogClose)
    }
  }

  showEditor(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.hasEditorTarget && this.editorTarget.tagName === "DIALOG") {
      if (!this.editorTarget.open) {
        this.editorTarget.showModal()
      }
      this.focusPrimaryField()
    } else {
      this.displayTarget.classList.add("hidden")
      this.editorTarget.classList.remove("hidden")
      this.focusPrimaryField()

      setTimeout(() => {
        document.addEventListener("click", this.boundCloseOnOutsideClick)
      }, 0)
    }
  }

  closeEditor(event) {
    if (event) {
      event.preventDefault()
    }

    if (this.hasEditorTarget && this.editorTarget.tagName === "DIALOG") {
      if (this.editorTarget.open) {
        this.editorTarget.close()
      }
    } else {
      this.displayTarget.classList.remove("hidden")
      this.editorTarget.classList.add("hidden")
      document.removeEventListener("click", this.boundCloseOnOutsideClick)
      this.resetForm()
    }
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.closeEditor()
    }
  }

  selectExisting(event) {
    event.preventDefault()
    const selectedTopic = this.selectTarget.value
    
    if (selectedTopic === "") {
      // Clear topic
      this.submitForm()
    } else if (selectedTopic === this.currentTopicValue) {
      // No change, just close
      this.closeEditor()
    } else {
      // Submit the form with selected topic
      this.submitForm()
    }
  }

  clearTopic(event) {
    event.preventDefault()
    if (this.hasSelectTarget) {
      this.selectTarget.value = ""
    }
    this.submitForm()
  }

  createNew(event) {
    event.preventDefault()
    const newTopicName = this.inputTarget.value.trim()
    
    if (newTopicName === "") {
      this.inputTarget.focus()
      return
    }
    
    // Set the new topic name and submit
    this.inputTarget.value = newTopicName
    this.submitForm()
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.closeEditor(event)
    } else if (event.key === "Enter" && event.target === this.inputTarget) {
      this.createNew(event)
    }
  }

  submitForm() {
    // Remove outside click listener before submitting
    document.removeEventListener("click", this.boundCloseOnOutsideClick)
    
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  handleDialogClose() {
    this.resetForm()
  }

  resetForm() {
    if (this.hasSelectTarget) {
      this.selectTarget.value = this.currentTopicValue || ""
    }
    if (this.hasInputTarget) {
      this.inputTarget.value = ""
    }
    if (this.hasDisplayTarget) {
      this.displayTarget.classList.remove("hidden")
    }
  }

  focusPrimaryField() {
    if (this.hasSelectTarget) {
      this.selectTarget.focus()
    }
  }
}
